import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * Input, the theme-aware text input.
 *
 * CSS selector: `mobile/atoms.css` `.ds-input` (+ `--big`, `--error`,
 * `--locked`).
 *
 * Doctrine: the focus ring is accent, because focus is a control state and
 * accent marks state. `big` is the roomy mobile flavour, and its bigness comes
 * entirely from padding, never from a larger font, so the text stays inside the
 * 15px to 16px guardrail. `locked` is the read-only value treatment: muted text
 * with the focus ring suppressed, because a locked field must never look
 * editable. Compose it through `<Field locked>` to get the trailing padlock.
 */
export const Input = React.forwardRef(function Input(
  { className, big = false, error = false, locked = false, readOnly, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      readOnly={readOnly === undefined ? locked || undefined : readOnly}
      aria-invalid={error || undefined}
      className={cn(
        'ds-input',
        big && 'ds-input--big',
        error && 'ds-input--error',
        locked && 'ds-input--locked',
        className,
      )}
      {...rest}
    />
  );
});

export default Input;
